export enum EQuickBetManagerDispatchActions {
  TOGGLE_QUICK_BET = 'TOGGLE_QUICK_BET'
}

export type TQuickBetState = {
  active: boolean;
  enabled: boolean;
};
